export default __webpack_public_path__ + "static/media/property_78.8737bc70.png";